// Copyright (c) 2016 Deere & Company

import actions from '../../../../sharedmodules/actions-list';
import { getDefaultState } from '../state';

const resetHasSearchRun = () => false;
const updateHasSearchRun = () => true;

export default (state = getDefaultState().hasSearchRun, action) => {

    const actionTypes = {
        [actions.RESET_DEALER_SEARCH_RESULTS]: resetHasSearchRun,
        [actions.UPDATE_DEALER_SEARCH_RESULTS_SUCCESS]: updateHasSearchRun,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
